// extracted by mini-css-extract-plugin
export default {"line_box":"index_line_box_P1FPZ","box":"index_box_jzOyT"};